import { ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  LayerData,
  setLayerState,
  setSublayerState,
} from '@rsos/reduxDataStore/src/features/layerOpacity/layerOpacitySlice';
import { AppState } from '../../../types/AppState';
import { StyledSlider } from './OpacitySlider.styles';

interface LayerProps {
  layerId: number;
}

interface SublayerProps {
  sublayerId: string;
}

export const OpacitySlider = (props: LayerProps | SublayerProps) => {
  const dispatch = useDispatch();

  const layers = useSelector((state: AppState) => state.layerOpacity.layers);

  const sublayers = useSelector(
    (state: AppState) => state.layerOpacity.sublayers,
  );

  const isSublayer = 'sublayerId' in props;

  const layerData: LayerData | undefined = isSublayer
    ? sublayers[props.sublayerId]
    : layers[props.layerId];

  const value = layerData?.opacity ?? 40;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (isSublayer) {
      return dispatch(
        setSublayerState({
          sublayerId: props.sublayerId,
          layerData: {
            opacity: Number(event.target.value),
          },
        }),
      );
    }
    dispatch(
      setLayerState({
        layerId: props.layerId,
        layerData: {
          opacity: Number(event.target.value),
        },
      }),
    );
  };

  return <StyledSlider onChange={handleChange} value={value} />;
};
